"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegendLayerLine = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
function LegendLayerLine({ title, layer, icon, level = 0, color, render }) {
    const [active, setActive] = react_1.default.useState(false);
    const [expanded, setExpanded] = react_1.default.useState(false);
    const onCheckboxChange = (value) => {
        setActive(value);
        layer?.setActive(value);
    };
    (0, react_1.useEffect)(() => {
        if (!layer)
            return;
        const c = () => {
            setActive(layer.isActive);
        };
        c();
        layer.addListener("activechange", c);
        return () => {
            layer.removeListener("activechange", c);
        };
    });
    const id = `legend-layer-line-${title}`;
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            display: "flex",
            flexDirection: "column",
        }, children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    height: 26,
                    alignItems: "center",
                }, children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            userSelect: "none",
                            pointerEvents: "auto",
                            marginLeft: level * 20,
                            gap: "5px",
                            flex: 1,
                        }, onClick: () => {
                            onCheckboxChange(!active);
                        }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                                    width: 20,
                                }, children: icon }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("input", { className: "form-check-input ", type: "checkbox", checked: active, id: id }) }), (0, jsx_runtime_1.jsx)("div", { children: title }), (0, jsx_runtime_1.jsx)("div", { style: {
                                    flex: 1,
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                }, children: color && (0, jsx_runtime_1.jsx)("div", { style: {
                                        backgroundColor: color,
                                        width: 13,
                                        height: 13,
                                        borderRadius: 5,
                                        // border: "1px solid black",
                                    } }) })] }), render && (0, jsx_runtime_1.jsx)("div", { children: expanded ?
                            (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm", style: {
                                    fontSize: 10,
                                }, onClick: () => setExpanded(false), children: "Zabalit -" })
                            :
                                (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm", style: {
                                        fontSize: 10,
                                    }, onClick: () => setExpanded(true), children: "Rozbalit +" }) })] }), (0, jsx_runtime_1.jsx)("div", { style: {
                    display: expanded ? "block" : "none",
                }, children: render?.(active) })] }));
}
exports.LegendLayerLine = LegendLayerLine;
